// src/components/SidebarTareas.jsx
import React, { useState } from "react";
import Modal from "react-modal";
import Swal from "sweetalert2";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import { db } from "../firebaseConfig";

Modal.setAppElement("#root");

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    width: "30%",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    padding: "20px",
    borderRadius: "10px",
    border: "1px solid #ccc",
    boxShadow: "0 5px 15px rgba(0, 0, 0, 0.3)",
    fontFamily: "Montserrat, sans-serif",
  },
  overlay: {
    backgroundColor: "rgba(0,0,0,0.4)",
    zIndex: 1000,
  },
  input: {
    width: "100%",
    padding: "8px",
    borderRadius: "5px",
    border: "1px solid #ccc",
    boxSizing: "border-box",
  },
};

const SidebarTareas = ({
  groups = [], // <= Aseguramos que no reviente si es undefined
  setGroups, // Para actualizar grupos si hace falta
  onSelectProject, // Función para seleccionar proyecto
  usuarios = [], // Usuarios para asignar en el modal de proyectos
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [groupName, setGroupName] = useState("");
  const [groupShape, setGroupShape] = useState("circle circle-blue");
  const [groupCategory, setGroupCategory] = useState("FAVORITOS");

  // Modal para crear proyecto
  const [projectModalOpen, setProjectModalOpen] = useState(false);
  const [projectName, setProjectName] = useState("");
  const [visibility, setVisibility] = useState("solo etiquetados");
  const [assignedTo, setAssignedTo] = useState([]);
  const [date, setDate] = useState("");
  const [tags, setTags] = useState([]);
  const [selectedGroupId, setSelectedGroupId] = useState(null);
  const [selectedGroupShape, setSelectedGroupShape] = useState("");

  // Manejo de secciones colapsables
  const [openSections, setOpenSections] = useState({
    favoritos: true,
    todos: true,
    archivo: true,
  });

  // Filtrar grupos por categoría
  const favoritos = groups.filter((g) => g.category === "FAVORITOS");
  const todos = groups.filter((g) => g.category === "TODOS");
  const archivo = groups.filter((g) => g.category === "ARCHIVO");

  // Abrir/cerrar modal de Crear Grupo
  const openModal = () => setIsModalOpen(true);
  const closeModal = () => {
    setIsModalOpen(false);
    setGroupName("");
    setGroupShape("circle circle-blue");
    setGroupCategory("FAVORITOS");
  };

  // Crear Grupo
  const handleSaveGroup = async () => {
    if (!groupName.trim()) {
      Swal.fire({
        title: "Error!",
        text: "Ingresa un nombre de grupoo",
        icon: "error",
        scrollbarPadding: false,
      });
      return;
    }
    try {
      const newGroup = {
        name: groupName,
        shape: groupShape,
        category: groupCategory,
        createdAt: serverTimestamp(),
      };
      const docRef = await addDoc(collection(db, "gruposTareas"), newGroup);

      // Si tienes setGroups en Tareas, esto te permite actualizarlo localmente
      if (setGroups) {
        setGroups((prev) => [
          ...prev,
          { ...newGroup, id: docRef.id, projects: [] },
        ]);
      }

      closeModal();
      Swal.fire({
        title: "¡Grupo creado!",
        text: "¡Grupo creado exitosamente!",
        icon: "success",
        scrollbarPadding: false,
      });
    } catch (error) {
      console.error("Error creando grupo:", error);
      Swal.fire({
        title: "Error!",
        text: "Ocurrió un error al crear el grupo",
        icon: "error",
        scrollbarPadding: false,
      });
    }
  };

  // Abrir/cerrar modal Crear Proyecto
  const openProjectModal = (groupId, shapeValue) => {
    setSelectedGroupId(groupId);
    setSelectedGroupShape(shapeValue);
    setProjectModalOpen(true);
  };
  const closeProjectModal = () => {
    setProjectModalOpen(false);
    setProjectName("");
    setVisibility("solo etiquetados");
    setAssignedTo([]);
    setDate("");
    setTags([]);
  };

  // Crear Proyecto
  const handleCreateProject = async () => {
    if (!projectName.trim()) {
      Swal.fire({
        title: "Error!",
        text: "Ingresa el nombre del proyecto",
        icon: "error",
        scrollbarPadding: false,
      });
      return;
    }
    try {
      const newProject = {
        projectName,
        visibility,
        assignedTo,
        date,
        tags,
        shape: selectedGroupShape,
        groupId: selectedGroupId,
        createdAt: serverTimestamp(),
      };
      // Guardar en subcolección
      const docRef = await addDoc(
        collection(db, "gruposTareas", selectedGroupId, "projects"),
        newProject
      );
      const createdProject = { ...newProject, id: docRef.id };

      // Actualizar local
      if (setGroups) {
        setGroups((prevGroups) =>
          prevGroups.map((g) =>
            g.id === selectedGroupId
              ? { ...g, projects: [...(g.projects || []), createdProject] }
              : g
          )
        );
      }

      closeProjectModal();
      Swal.fire({
        title: "Proyecto creado",
        text: "Proyecto creado correctamente",
        icon: "success",
        scrollbarPadding: false,
      });
    } catch (error) {
      console.error("Error al crear el proyecto:", error);
      Swal.fire("Error", "No se pudo crear el proyecto", "error");
      Swal.fire({
        title: "Error",
        text: "No se pudo crear el proyecto",
        icon: "error",
        scrollbarPadding: false,
      });
    }
  };

  const pastelColors = ["#FBE6FC", "#D9F4F8", "#FFECE1", "#E1F6FF", "#6ae88e"];

  const tagTextColors = ["#FF00B8", "#268FB0", "#FF5C00", "#2C62B4", "#038554"];

  return (
    <div className="sidebar-tareas">
      <div className="barra-grupos">
        <span style={{ fontSize: "16px", fontWeight: "bold" }}>Grupos</span>
        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          <div className="agregar-grupo" onClick={openModal}>
            <i className="bi bi-plus"></i>
          </div>
          <div style={{ fontSize: "20px" }}>
            <i
              className="bi bi-filter-circle"
              style={{ cursor: "pointer", color: "#007DFC" }}
            ></i>
          </div>
        </div>
      </div>

      {/* Barra de búsqueda */}
      <div className="sidebar-search">
        <i className="bi bi-search" style={{ marginRight: "5px" }}></i>
        <input type="text" placeholder="Buscar" />
      </div>

      {/* Sección: FAVORITOS */}
      <div className="sidebar-section">
        <h4
          className="sidebar-title"
          style={{ cursor: "pointer" }}
          onClick={() =>
            setOpenSections((prev) => ({
              ...prev,
              favoritos: !prev.favoritos,
            }))
          }
        >
          <span style={{ marginRight: "5px" }}>
            {openSections.favoritos ? (
              <i className="bi bi-chevron-down"></i>
            ) : (
              <i className="bi bi-chevron-right"></i>
            )}
          </span>
          FAVORITOS
        </h4>
        {openSections.favoritos && (
          <ul className="sidebar-list">
            {favoritos.map((group) => (
              <li key={group.id} className="group-item">
                <div className="group-row">
                  <span
                    className={group.shape}
                    style={{ marginRight: "8px" }}
                  ></span>
                  {group.name}
                  <span
                    className="plus-icon"
                    onClick={() => openProjectModal(group.id, group.shape)}
                  >
                    <i className="bi bi-plus"></i>
                  </span>
                </div>
                {group.projects?.length > 0 && (
                  <ul className="sub-list">
                    {group.projects.map((project) => (
                      <li
                        key={project.id}
                        onClick={() =>
                          onSelectProject({ ...project, groupId: group.id })
                        }
                        className="project-item"
                      >
                        <span
                          className={project.shape}
                          style={{ marginRight: "6px" }}
                        ></span>
                        <span style={{ color: "#007bff" }}>
                          {project.projectName}
                        </span>
                      </li>
                    ))}
                  </ul>
                )}
              </li>
            ))}
          </ul>
        )}
      </div>

      {/* Sección: TODOS */}
      <div className="sidebar-section">
        <h4
          className="sidebar-title"
          style={{ cursor: "pointer" }}
          onClick={() =>
            setOpenSections((prev) => ({
              ...prev,
              todos: !prev.todos,
            }))
          }
        >
          <span style={{ marginRight: "5px" }}>
            {openSections.todos ? (
              <i className="bi bi-chevron-down"></i>
            ) : (
              <i className="bi bi-chevron-right"></i>
            )}
          </span>
          TODOS
        </h4>
        {openSections.todos && (
          <ul className="sidebar-list">
            {todos.map((group) => (
              <li key={group.id} className="group-item">
                <div className="group-row">
                  <span
                    className={group.shape}
                    style={{ marginRight: "8px" }}
                  ></span>
                  {group.name}
                  <span
                    className="plus-icon"
                    onClick={() => openProjectModal(group.id, group.shape)}
                  >
                    <i className="bi bi-plus"></i>
                  </span>
                </div>
                {group.projects?.length > 0 && (
                  <ul className="sub-list">
                    {group.projects.map((project) => (
                      <li
                        key={project.id}
                        onClick={() =>
                          onSelectProject({ ...project, groupId: group.id })
                        }
                        className="project-item"
                      >
                        <span
                          className={project.shape}
                          style={{ marginRight: "6px" }}
                        ></span>
                        <span style={{ color: "#007bff" }}>
                          {project.projectName}
                        </span>
                      </li>
                    ))}
                  </ul>
                )}
              </li>
            ))}
          </ul>
        )}
      </div>

      {/* Sección: ARCHIVO */}
      <div className="sidebar-section">
        <h4
          className="sidebar-title"
          style={{ cursor: "pointer" }}
          onClick={() =>
            setOpenSections((prev) => ({
              ...prev,
              archivo: !prev.archivo,
            }))
          }
        >
          <span style={{ marginRight: "5px" }}>
            {openSections.archivo ? (
              <i className="bi bi-chevron-down"></i>
            ) : (
              <i className="bi bi-chevron-right"></i>
            )}
          </span>
          ARCHIVOS
        </h4>
        {openSections.archivo && (
          <ul className="sidebar-list">
            {archivo.map((group) => (
              <li key={group.id} className="group-item">
                <div className="group-row">
                  <span
                    className={group.shape}
                    style={{ marginRight: "8px" }}
                  ></span>
                  {group.name}
                  <span
                    className="plus-icon"
                    onClick={() => openProjectModal(group.id, group.shape)}
                  >
                    <i className="bi bi-plus"></i>
                  </span>
                </div>
                {group.projects?.length > 0 && (
                  <ul className="sub-list">
                    {group.projects.map((project) => (
                      <li
                        key={project.id}
                        onClick={() =>
                          onSelectProject({ ...project, groupId: group.id })
                        }
                        className="project-item"
                      >
                        <span
                          className={project.shape}
                          style={{ marginRight: "6px" }}
                        ></span>
                        <span style={{ color: "#007bff" }}>
                          {project.projectName}
                        </span>
                      </li>
                    ))}
                  </ul>
                )}
              </li>
            ))}
          </ul>
        )}
      </div>

      {/* Modal: Crear Grupo */}
      <Modal
        isOpen={isModalOpen}
        onRequestClose={closeModal}
        style={customStyles}
      >
        <button onClick={closeModal} className="modal-close">
          <i className="bi bi-x-lg"></i>
        </button>
        <h2 style={{ marginBottom: "20px", textAlign: "center" }}>
          Crear Nuevo Grupo
        </h2>
        <div style={{ marginBottom: "15px" }}>
          <label style={{ display: "block", marginBottom: "5px" }}>
            Nombre del Grupo:
          </label>
          <input
            type="text"
            value={groupName}
            onChange={(e) => setGroupName(e.target.value)}
            style={customStyles.input}
          />
        </div>
        <div style={{ marginBottom: "15px" }}>
          <label style={{ display: "block", marginBottom: "5px" }}>
            Figura/Ícono:
          </label>
          <select
            value={groupShape}
            onChange={(e) => setGroupShape(e.target.value)}
            style={{
              width: "100%",
              padding: "8px",
              borderRadius: "4px",
              border: "1px solid #ccc",
              fontSize: "14px",
            }}
          >
            <option value="circle circle-blue">Círculo Azul</option>
            <option value="circle circle-green">Círculo Verde</option>
            <option value="triangle triangle-orange">Triángulo Naranja</option>
          </select>
        </div>
        <div style={{ marginBottom: "20px" }}>
          <label style={{ display: "block", marginBottom: "5px" }}>
            Categoría:
          </label>
          <select
            value={groupCategory}
            onChange={(e) => setGroupCategory(e.target.value)}
            style={{
              width: "100%",
              padding: "8px",
              borderRadius: "4px",
              border: "1px solid #ccc",
              fontSize: "14px",
            }}
          >
            <option value="FAVORITOS">FAVORITOS</option>
            <option value="TODOS">TODOS</option>
            <option value="ARCHIVO">ARCHIVO</option>
          </select>
        </div>
        <div
          style={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}
        >
          <button
            onClick={closeModal}
            style={{
              padding: "8px 16px",
              border: "none",
              backgroundColor: "#ddd",
              borderRadius: "4px",
              cursor: "pointer",
              fontSize: "14px",
            }}
          >
            Cancelar
          </button>
          <button
            onClick={handleSaveGroup}
            style={{
              padding: "8px 16px",
              border: "none",
              backgroundColor: "#007bff",
              color: "#fff",
              borderRadius: "4px",
              cursor: "pointer",
              fontSize: "14px",
            }}
          >
            Crear Grupo
          </button>
        </div>
      </Modal>

      {/* Modal: Crear Proyecto */}
      <Modal
        isOpen={projectModalOpen}
        onRequestClose={closeProjectModal}
        contentLabel="Crear Proyecto"
        style={customStyles}
      >
        <button
          onClick={closeProjectModal}
          className="modal-close"
          style={{
            position: "absolute",
            top: "10px",
            right: "10px",
            border: "none",
            background: "none",
            cursor: "pointer",
          }}
        >
          <i className="bi bi-x-lg"></i>
        </button>
        <h2 style={{ marginBottom: "20px", textAlign: "center" }}>
          Crear Nuevo Proyecto
        </h2>

        <div style={{ marginBottom: "15px" }}>
          <label style={{ display: "block", marginBottom: "5px" }}>
            Nombre del Proyecto:
          </label>
          <input
            type="text"
            value={projectName}
            onChange={(e) => setProjectName(e.target.value)}
            style={customStyles.input}
          />
        </div>

        <div style={{ marginBottom: "15px" }}>
          <label style={{ display: "block", marginBottom: "5px" }}>
            Visibilidad:
          </label>
          <select
            value={visibility}
            onChange={(e) => setVisibility(e.target.value)}
            style={{
              width: "100%",
              padding: "8px",
              borderRadius: "4px",
              border: "1px solid #ccc",
              fontSize: "14px",
            }}
          >
            <option value="solo etiquetados">Solo Etiquetados</option>
            <option value="publico">Público</option>
          </select>
        </div>

        {/* Asignado a */}
        <div style={{ marginBottom: "15px" }}>
          <label style={{ display: "block", marginBottom: "5px" }}>
            Asignado a:
          </label>
          <div
            style={{
              ...customStyles.input,
              display: "flex",
              flexWrap: "wrap",
              gap: "5px",
              alignItems: "center",
            }}
          >
            {assignedTo.map((user, index) => (
              <div
                key={user.id || index}
                style={{
                  display: "flex",
                  alignItems: "center",
                  background: "#007bff",
                  color: "#fff",
                  borderRadius: "5px",
                  padding: "4px 8px",
                  fontSize: "14px",
                  cursor: "pointer",
                  marginBottom: "4px",
                }}
                onClick={() =>
                  setAssignedTo(assignedTo.filter((_, i) => i !== index))
                }
              >
                <img
                  src={user.avatarUrl || "/img/avatar2.jpg"}
                  alt="avatar"
                  style={{
                    width: "30px",
                    height: "30px",
                    borderRadius: "50%",
                    marginRight: "5px",
                    objectFit: "cover",
                  }}
                />
                {user.nombre ? `${user.nombre} ${user.apellido}` : user.email}
                <span style={{ marginLeft: "5px" }}>
                  <i className="bi bi-x"></i>
                </span>
              </div>
            ))}
            <select
              onChange={(e) => {
                const selectedUserId = e.target.value;
                if (selectedUserId) {
                  const selectedUser = usuarios.find(
                    (u) => u.id === selectedUserId
                  );
                  if (
                    selectedUser &&
                    !assignedTo.some((user) => user.id === selectedUser.id)
                  ) {
                    setAssignedTo([...assignedTo, selectedUser]);
                  }
                }
                e.target.value = "";
              }}
              style={{
                border: "none",
                outline: "none",
                backgroundColor: "transparent",
                flexGrow: 1,
              }}
            >
              <option value="">Agregar usuario</option>
              {usuarios
                .filter(
                  (u) =>
                    u.nombre &&
                    u.apellido &&
                    !assignedTo.some((user) => user.id === u.id)
                )
                .map((u) => (
                  <option key={u.id} value={u.id}>
                    {u.nombre} {u.apellido}
                  </option>
                ))}
            </select>
          </div>
        </div>

        <div style={{ marginBottom: "15px" }}>
          <label style={{ display: "block", marginBottom: "5px" }}>
            Fecha:
          </label>
          <input
            type="date"
            value={date}
            onChange={(e) => setDate(e.target.value)}
            style={customStyles.input}
          />
        </div>

        {/* Etiquetas */}
        <div style={{ marginBottom: "15px" }}>
          <label style={{ display: "block", marginBottom: "5px" }}>
            Etiquetas: (máx 5)
          </label>
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              gap: "10px",
              borderRadius: "8px",
              marginTop: "5px",
              marginBottom: "5px",
              overflowY: "auto",
            }}
          >
            {tags.map((tag, index) => (
              <div
                key={index}
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  backgroundColor: pastelColors[index % pastelColors.length],
                  color: tagTextColors[index % tagTextColors.length],
                  fontWeight: "bold",
                  borderRadius: "20px",
                  padding: "6px 12px",
                  fontSize: "12px",
                  boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                }}
              >
                {tag}
                <span
                  style={{ marginLeft: "8px", cursor: "pointer" }}
                  onClick={() => setTags(tags.filter((_, i) => i !== index))}
                >
                  <i className="bi bi-x"></i>
                </span>
              </div>
            ))}
            {tags.length < 5 && (
              <input
                type="text"
                placeholder="Escribe y presiona Enter..."
                style={customStyles.input}
                onKeyDown={(e) => {
                  if (e.key === "Enter" && e.target.value.trim() !== "") {
                    if (!tags.includes(e.target.value.trim())) {
                      setTags([...tags, e.target.value.trim()]);
                    }
                    e.target.value = "";
                  }
                }}
              />
            )}
          </div>
        </div>

        <div
          style={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}
        >
          <button
            onClick={closeProjectModal}
            style={{
              padding: "8px 16px",
              border: "none",
              backgroundColor: "#ddd",
              borderRadius: "4px",
              cursor: "pointer",
              fontSize: "14px",
            }}
          >
            Cancelar
          </button>
          <button
            onClick={handleCreateProject}
            style={{
              padding: "8px 16px",
              border: "none",
              backgroundColor: "#007bff",
              color: "#fff",
              borderRadius: "4px",
              cursor: "pointer",
              fontSize: "14px",
            }}
          >
            Crear Proyecto
          </button>
        </div>
      </Modal>
    </div>
  );
};

export default SidebarTareas;
